import { render } from "./ScaleChartList.vue?vue&type=template&id=2155f018"
import script from "./ScaleChartList.vue?vue&type=script&lang=js"
export * from "./ScaleChartList.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__